export const isLoggedInAsAgentInApp = (): Promise<boolean> => {
  // Explained here -> https://wix.slack.com/archives/CSFELEMDW/p1592923950003400?thread_ts=1592920520.002400&cid=CSFELEMDW
  const CHECK_TIMEOUT = 5000;

  // hide toolbar on mobile
  try {
    const isMobile = window.innerWidth < 767;
    if (isMobile) {
      return Promise.resolve(false);
    }
  } catch (e) {
    console.warn('Cant check if mobile');
  }

  return new Promise((res, rej) => {
    const timeoutTimer = setTimeout(() => {
      window.removeEventListener('message', receiveMessage);

      rej(false);
    }, CHECK_TIMEOUT);

    function receiveMessage(event) {
      if (event.data && typeof event.data.isAgent === 'boolean') {
        window.removeEventListener('message', receiveMessage);
        res(event.data.isAgent);
      }
    }

    const iframe = document.querySelector(
      '#agent-check-iframe',
    ) as HTMLIFrameElement;

    if (iframe && iframe.contentWindow) {
      const { contentWindow } = iframe;
      contentWindow.postMessage('getIsAgent', '*');
      iframe.addEventListener('load', () => {
        contentWindow.postMessage('getIsAgent', '*');
      });
    } else {
      window.removeEventListener('message', receiveMessage);
      rej(false);
    }

    window.addEventListener('message', receiveMessage, false);
  });
};
